import { useLayoutEffect, useState } from 'react'

////////TO DETECT CHANGE IN SCREEN SIZE///////
export const useMediaQuery = () => {
  const [screenSize, setScreenSize] = useState([0, 0])

  useLayoutEffect(() => {
    const updateScreenSize = () => {
      setScreenSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', updateScreenSize)
    updateScreenSize()
    return () => window.removeEventListener('resize', updateScreenSize)
  }, [])

  return screenSize
}
